import React from "react";

import { mdiAvTimer, mdiCalendarMonthOutline, mdiClockOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import Block from "../../block/Block";
import Input from "../../form/Input";
import Select from "../../form/Select";

import type { JSX } from "react";

export default function SchedulingSettings(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const firstDayOfWeekOptions = [
    {
      value: "saturday",
      label: t("saturday", { ns: "common" }),
    },
    {
      value: "sunday",
      label: t("sunday", { ns: "common" }),
    },
    {
      value: "monday",
      label: t("monday", { ns: "common" }),
    },
  ];

  const firstHourOfDayOptions = new Array(24).fill(0).map((_, index) => ({
    value: index.toString().padStart(2, "0"),
    label: `${index.toString().padStart(2, "0")}h00`,
  }));

  return (
    <Block title={t("schedule-settings")} zIndex={1}>
      <Select
        isRequired
        icon={<Icon path={mdiCalendarMonthOutline} size={0.9375} />}
        label={t("firstDayOfWeek")}
        name="firstDayOfWeek"
        options={firstDayOfWeekOptions}
      />
      <Select
        isPortal
        isRequired
        icon={<Icon path={mdiAvTimer} size={0.9375} />}
        label={t("firstHourOfDay")}
        name="firstHourOfDay"
        options={firstHourOfDayOptions}
      />
      <Input
        isReadOnly
        className="mb-[unset]"
        icon={<Icon path={mdiClockOutline} size={0.9375} />}
        label={t("productionTimezone")}
        name="timezone"
        value="GMT Standard Time"
      />
    </Block>
  );
}
